// extracted by mini-css-extract-plugin
export default {"mainCont":"WorlLine_mainCont__l6NLL","title":"WorlLine_title__16bHY","ldrCont":"WorlLine_ldrCont__+wDZu"};